<template>
    <div>
        <div>
            <app-tabela
                :itens="contrato.documentosContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="acoes" slot-scope="data">
                    <btn-download-documento
                        :documento="data"
                        :dataServicos="dataServicos"
                    ></btn-download-documento>
                </template>
            </app-tabela>
        </div>
    </div>
</template>

<script>
import BtnDownloadDocumento from './BtnDownloadDocumento'

export default {
    components: {
        BtnDownloadDocumento
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        },

        dataServicos: {
            type: Object
        }
    },

    data() {
        return {
            documento: null,
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'tipoDocumento',
                    label: 'Tipo do Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoDocumento',
                    label: 'Descrição',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivo',
                    label: 'Arquivo',
                    filterable: true,
                    sortable: true
                }
            ],
            itensPorPagina: 10
        }
    }
}
</script>
